import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { ActiveSign, AgentName, Avatar, ChatMessage, ChatScreen, ContactNumber, Group, KeypadOption, LeftMsg, MsgSend, ProfileBar, RightMsg, Sign } from '../styles/dialpadstyle';
import {
  FormWrapper,
  FormColumn,
  FormGroup,
  ControlLabel,
  FormControl,
  Button
} from 'modules/theme';

export class MessageListTheme extends Component {

  renderFormGroup(label, props) {
    return (
      <FormGroup>
        {/* <ControlLabel required={props.required}>{label}</ControlLabel> */}
        <FormControl {...props} />
      </FormGroup>
    );
  }

  renderLeftMsg(leftMsg) {
    return (
      <div className='pad'>
        <LeftMsg>
          {leftMsg}
        </LeftMsg>
      </div>
    )
  }

  renderRightMsg(rightMsg) {
    return (
      <div className='pad'>
        <RightMsg>
          {rightMsg}
        </RightMsg>
      </div>
    )
  }


  render() {

    const { userImg, sign, name, number, btnSend } = this.props;

    return (
      <span>
        <ChatScreen>
          <ProfileBar style={{ padding: '0px', marginBottom: '10px' }}>
            <Avatar>
              <img src={userImg} />
              <ActiveSign><Sign className={sign} /></ActiveSign>
            </Avatar>
            <AgentName style={{ color: '#303030' }}>{name}<ContactNumber>{number}</ContactNumber></AgentName>
          </ProfileBar>
        </ChatScreen>

        <ChatMessage>
          {this.renderLeftMsg(
            'Hi Jake, how are you? I saw on Jungle that we have Dragonfly in common. 😄'
          )}
          {this.renderRightMsg(
            'Haha truly! Nice to meet you Grace! What about a cup of coffee today evening? ☕️'
          )}
          {this.renderLeftMsg(
            'Sure, let’s do it! 😊'
          )}
          {this.renderRightMsg(
            'Great I will write later the exact time and place. See you soon!'
          )}
          {this.renderLeftMsg(
            'Hi Jake, how are you? I saw on Jungle that we have Dragonfly in common. 😄'
          )}
          {this.renderRightMsg(
            'Haha truly! Nice to meet you Grace! What about a cup of coffee today evening? ☕️'
          )}
        </ChatMessage>
        <MsgSend>
          <Group style={{ marginTop: '8px', marginBottom: '0px' }}>
            <form style={{ width: '82%' }}>
              <KeypadOption>
                <FormWrapper>
                  {/* <FormColumn></FormColumn> */}
                  <FormColumn>
                    {this.renderFormGroup('', {
                      defaultValue: '',
                      placeholder: 'Send Message',
                      autoFocus: false,
                      required: true,
                      id: 'msg',
                      value: '',
                      onChange: e => {
                        this.setState({ msg: e.target.value });
                      }
                    })}
                  </FormColumn>
                </FormWrapper>
              </KeypadOption>
              <Button
                btnStyle="link"
                type="simple"
                style={{ right: '-3px' }}
              >
                <img src={btnSend} style={{ width: '38px' }} />
              </Button>
            </form>
          </Group>
        </MsgSend>
      </span>
    )
  }
}

MessageListTheme.propTypes = {
};

MessageListTheme.contextTypes = {
  __: PropTypes.func
};

export default MessageListTheme


// WEBPACK FOOTER //
// src/modules/theme/theme1/common/components/MessageListTheme.js